import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getAllProvince } from '../store/features/basicInfo/basicInfoSlice'
import { TOptions } from '../types/generalType'
import { useAppDispatch, useAppSelector } from './useStore'

type Parametres = {
  hasAll: boolean
}

type UseProvinceProps = (options?: Parametres) => {
  provinceLoading: boolean
  provinceSelectOptions: TOptions[]
  borkerProvinceSelectOptions: TOptions[]
}

const useProvince: UseProvinceProps = (options) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const povinceInit: TOptions[] = options?.hasAll ? [{ value: '0', label: t('allProvince') }] : []
  const [provinceSelectOptions, setProvinceSelectOptions] = useState<TOptions[]>(povinceInit)
  const [borkerProvinceSelectOptions, setBorkerProvinceSelectOptions] =
    useState<TOptions[]>(povinceInit)

  const { loading, dataList } = useAppSelector((state) => state.basicInfo.province.provinceList)

  const { provinceBrokerId } = useAppSelector((state) => state.auth.userInfo)

  useEffect(() => {
    const provinceQuery = {
      pageSize: 100,
      pageNumber: 1,
    }
    dispatch(getAllProvince(provinceQuery))
  }, [])

  useEffect(() => {
    const provinceOptions = dataList.data.map((item) => ({
      value: item.id,
      label: item.title,
    }))
    const newProvices = [...provinceSelectOptions, ...provinceOptions]
    setProvinceSelectOptions(newProvices)
  }, [dataList.data])

  useEffect(() => {
    if (provinceBrokerId) {
      const borkerProviceIds = provinceBrokerId.split(',')
      const newProvinces = [...borkerProvinceSelectOptions]

      borkerProviceIds.forEach((id) => {
        dataList.data.forEach((province) => {
          if (province.id == id) {
            const provinceIndex = newProvinces.findIndex((item) => item.value == province.id)
            if (provinceIndex === -1) {
              newProvinces.push({
                value: province.id,
                label: province.title,
              })
            }
          }
        })
      })
      setBorkerProvinceSelectOptions(newProvinces)
    }
  }, [dataList.data])

  return {
    provinceLoading: loading,
    provinceSelectOptions,
    borkerProvinceSelectOptions,
  }
}

export default useProvince
